module.exports = { "default": require("core-js/library/fn/symbol/iterator"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/recompose/~/babel-runtime/core-js/symbol/iterator.js
// module id = 1788
// module chunks = 0